import { render, staticRenderFns } from "./NotificationNotice.vue?vue&type=template&id=4acdda23&"
import script from "./NotificationNotice.vue?vue&type=script&lang=js&"
export * from "./NotificationNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports